angular.module('FlexyBeautyApp.services')
    .factory('ExternalServiceLoader', ["$filter", "$location", "bugsnag", "LanguageManager", "HumanResourceData", "SupportedLocales",
        function ($filter, $location, bugsnag, LanguageManager, HumanResourceData, SupportedLocales) {
            let externalServiceLoader = {};

            externalServiceLoader.initFullStory = function (loggedUser, currentUser) {
                try {
                    if (loggedUser) {
                        let fullStoryId = loggedUser.company.code + (currentUser ? ("_" + currentUser.token) : ""),
                            fullStoryName = loggedUser.company.name + (currentUser ? ("_" + currentUser.token) : "");

                        if (loggedUser.company.type === 'partner') {
                            window['_fs_debug'] = false;
                            window['_fs_host'] = 'fullstory.com';
                            window['_fs_org'] = 'D6VXA';
                            window['_fs_namespace'] = 'FS';
                            (function (m, n, e, t, l, o, g, y) {
                                if (e in m) {
                                    if (m.console && m.console.log) {
                                        m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
                                    }
                                    return;
                                }
                                g = m[e] = function (a, b) {
                                    g.q ? g.q.push([a, b]) : g._api(a, b);
                                };
                                g.q = [];
                                o = n.createElement(t);
                                o.async = 1;
                                o.src = 'https://' + _fs_host + '/s/fs.js';
                                y = n.getElementsByTagName(t)[0];
                                y.parentNode.insertBefore(o, y);
                                g.identify = function (i, v) {
                                    g(l, {uid: i});
                                    if (v) g(l, v)
                                };
                                g.setUserVars = function (v) {
                                    g(l, v)
                                };
                                g.event = function (v) {
                                    g('event', {n: i, p: v})
                                };
                                g.shutdown = function () {
                                    g("rec", !1)
                                };
                                g.restart = function () {
                                    g("rec", !0)
                                };
                                g.consent = function (a) {
                                    g("consent", !arguments.length || a)
                                };
                                g.identifyAccount = function (i, v) {
                                    o = 'account';
                                    v = v || {};
                                    v.acctId = i;
                                    g(o, v)
                                };
                                g.clearUserCookie = function () {
                                };
                            })(window, document, window['_fs_namespace'], 'script', 'user');

                            // This is an example script - don't forget to change it!
                            FS.identify(fullStoryId, {
                                displayName: fullStoryName,
                                email: loggedUser.email,
                                // TODO: Add your own custom user variables here, details at
                                // http://help.fullstory.com/develop-js/setuservars
                                reviewsWritten_int: 14,
                                "flexyApplication": "proSite"
                            });
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            externalServiceLoader.initBugsnag = function (loggedUser) {
                try {
                    if (loggedUser) {
                        if (loggedUser.serverIdentification && loggedUser.serverIdentification.applicationId && loggedUser.serverIdentification.version) {
                            if (loggedUser.serverIdentification.applicationId !== "bsiflexyprod") {
                                bugsnag.releaseStage = "development";
                            }
                            bugsnag.appVersion = loggedUser.serverIdentification.version;
                        }
                        bugsnag.user = {
                            id: loggedUser.company.code,
                            name: loggedUser.company.name,
                            email: loggedUser.email
                        };
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            externalServiceLoader.initChameleon = function (loggedUser, activeOfferCode) {
                try {
                    let CHAMELEON_DISPLAY_PERIOD = 2;
                    let timeCreated = loggedUser.company.timeCreated;

                    if (timeCreated) {
                        let currentDate = new Date();
                        let limitDateForChameleon = new Date();
                        limitDateForChameleon.setFullYear(timeCreated.getFullYear());
                        limitDateForChameleon.setMonth(timeCreated.getMonth() + CHAMELEON_DISPLAY_PERIOD);
                        limitDateForChameleon.setDate(timeCreated.getDate());
                        limitDateForChameleon.setHours(timeCreated.getHours());
                        limitDateForChameleon.setMinutes(timeCreated.getMinutes());
                        limitDateForChameleon.setSeconds(timeCreated.getSeconds());
                        if (currentDate < limitDateForChameleon) {
                            let formattedTimeCreated = $filter('date')(timeCreated, 'yyyy-MM-ddTHH:mm:ssZ');

                            let chmlnSnippet = document.createElement('script');
                            chmlnSnippet.type = 'text/javascript';
                            chmlnSnippet.async = true;
                            chmlnSnippet.text = '/* Chameleon - better user onboarding */!function(t,n,o){var a="chmln",e="adminPreview",c="setup identify alias track clear set show on off custom help _data".split(" ");if(n[a]||(n[a]={}),n[a][e]&&(n[a][e]=!1),!n[a].root){n[a].accountToken=o,n[a].location=n.location.href.toString(),n[a].now=new Date;for(var s=0;s<c.length;s++)!function(){var t=n[a][c[s]+"_a"]=[];n[a][c[s]]=function(){t.push(arguments)}}();var i=t.createElement("script");i.src="https://fast.trychameleon.com/messo/"+o+"/messo.min.js",i.async=!0,t.head.appendChild(i)}}(document,window,"SIVZzaHSq2DTB8ETPRQZixuRPjHmFAoo9VCNFOZXBsROwa-1FnEti-AEc6qBIRcsYwH9o8");';
                            document.head.appendChild(chmlnSnippet);

                            if (activeOfferCode) {
                                chmln.identify({
                                    uid: loggedUser.id,                      // Unique ID of each user in your database (e.g. 23443 or "590b80e5f433ea81b96c9bf6")
                                    email: loggedUser.email,                  // Put quotes around text strings (e.g. "jim@example.com")
                                    created: formattedTimeCreated,
                                    company: {                                 // For B2B products, send company / account information here
                                        uid: loggedUser.company.code,         // Unique ID of the company / account in your database (e.g. 9832 or "590b80e5f433ea81b96c9bf7")
                                        name: loggedUser.company.type,        // Send any data that appears within URLs, such as subdomains (e.g. "airbnb")
                                        plan: activeOfferCode,
                                        spend: LanguageManager.getLanguageCode()
                                    }
                                });
                            }
                        }
                    }

                } catch (error) {
                    console.error(error);
                }
            };

            externalServiceLoader.initLokalise = function () {
                try {
                    if (LanguageManager.canAccessLiveEdit()) {
                        window.LOKALISE_CONFIG = {
                            projectId: "625966535b44b267eeeae8.51499813",
                            locale: LanguageManager.locale.gettextLocale
                        };
                        (function () {
                            var a = document.createElement("script");
                            a.type = "text/javascript";
                            a.async = !0;
                            a.src = ["https://lokalise.co/live-js/script.min.js?", (new Date).getTime()].join("");
                            document.body.appendChild(a)
                        })();
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            externalServiceLoader.initIntercom = function (loggedUser, activeOffer, intercomAppId) {
                try {
                    if (loggedUser && loggedUser.company && activeOffer) {
                        let arr = $location.absUrl().split("/"),
                            startUrl = arr[0] + "//" + arr[2],
                            nbHr = 1,
                            hrList = HumanResourceData.getActiveList();

                        if (hrList)
                            nbHr = hrList.length;

                        if (window.Intercom && Upscope) {
                            window.Intercom("boot", {
                                app_id: intercomAppId,
                                user_id: loggedUser.id,
                                name: loggedUser.firstName + " " + loggedUser.lastName, // Full name
                                email: loggedUser.email, // Email address
                                phone: loggedUser.phone,
                                created_at: loggedUser.company.timeCreated, // Signup date as a Unix timestamp
                                company: {
                                    id: loggedUser.company.code,
                                    name: loggedUser.company.name,
                                    type: loggedUser.company.type,
                                    connectUrl: startUrl + "/fxbAdmin/" + loggedUser.company.code,
                                    created_at: loggedUser.company.timeCreated,
                                    plan: activeOffer.code,
                                    monthly_spend: activeOffer.price,
                                    industry: loggedUser.company.startModel,
                                    mangopay_ID: loggedUser.company.companyPaymentData ? loggedUser.company.companyPaymentData.userId : null,
                                    size: nbHr,
                                    country: loggedUser.company.country,
                                    website: startUrl + "/" + loggedUser.company.code,
                                }
                            });
                            Upscope('init', {
                                // Optionally set the user ID below. If you don't have it, it doesn't matter,
                                // Upscope will integrate with your live chat system anyway.
                                uniqueId: loggedUser.id,
                                // Optionally set the user name or email below (e.g. ["John Smith", "john.smith@acme.com"])
                                identities: [loggedUser.firstName + " " + loggedUser.lastName, loggedUser.email]
                            });

                            if (!LanguageManager.isFrenchLanguage()) {
                                window.intercomSettings = {
                                    app_id: intercomAppId,
                                    language_override: SupportedLocales["en"]["GB"].languageCode
                                };
                                window.Intercom('update', intercomSettings);
                            }
                        }
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            return externalServiceLoader;
        }]);



// WEBPACK FOOTER //
// ./js/services/tools/ExternalServiceLoader.js